import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink, RouterLinkActive, RouterOutlet, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ModalService } from '../../../services/modal.service';
import { Observable } from 'rxjs';

import { ZSNOrder, ZSNOrderItem } from '../../../models/zsn.model';
import { CampaignYearPipe } from '../../../pipes/campaignYear.pipe';
import { CapitalizePipe } from '../../../pipes/capitalize.pipe';
import { HectareConverterPipe } from '../../../pipes/hectareConverter.pipe';
import { ZSNService } from '../../../services/zsn.service';
// FIXME commun à tous pas juste agrorendement
import { I18nTranslator } from '../../../i18n/translate';
import { ParcelService } from '../../../services/parcel.service';
import { PreventDoubleClickDirective } from '../../../utils/preventDoubleClick';
import { AROrderEditComponent } from '../agrorendement/common/order-edit.component';
import { TranslatePipe, TranslateWithPunctuationPipe } from '../../../pipes/translate.pipe';
import { FormsModule } from '@angular/forms';

@Component({
  standalone: true,
  selector: 'zsn-order-edit',
  templateUrl: '../agrorendement/common/order-edit.component.html',
  imports: [RouterLink, RouterLinkActive, RouterOutlet, CommonModule, PreventDoubleClickDirective, CampaignYearPipe, CapitalizePipe, HectareConverterPipe, TranslatePipe, TranslateWithPunctuationPipe, FormsModule],
  providers: [ZSNService, ParcelService],
})
export class ZSNOrderEditComponent extends AROrderEditComponent<ZSNOrder, ZSNOrderItem> implements OnInit, OnDestroy {
  @Input() orderItem: ZSNOrderItem;

  constructor(
    protected service: ZSNService,
    protected parcelService: ParcelService,
    protected i18nTranslator: I18nTranslator,
    protected modal: ModalService,
    protected router: Router,
    protected route: ActivatedRoute,
  ) {
    super();
    this.specyString = this.i18nTranslator.translate('ar.zsn.section');
    this.specyUrlPart = ['zsn'];
    this.specyOrderCode = 'ORDZ';
    this.specyIconClass = 'fa-circle-o';
    this.routeActionIndex = 3;
    this.toolStatusCode = 'ZSN';
  }

  buildNew(): ZSNOrder {
    return new ZSNOrder();
  }

  remoteGetOrderItems(orderItemIds: Array<number>): Observable<ZSNOrderItem[]> {
    return this.service.getOrderItems(orderItemIds, null, false);
  }

  remoteGetOrderItem(orderItemId: number): Observable<ZSNOrderItem> {
    return this.service.getOrderItem(orderItemId);
  }
}
